/**
 * WhatsApp Business Account signup page.
 * This is where users connect their WhatsApp Business Account.
 */

"use client";

import { Suspense } from "react";
import { ContentSection } from "@zapier/design-system";
import { WabaSignupModal } from "../components/WabaSignupModal";

// Force this page to be dynamic since it uses cookies
export const dynamic = "force-dynamic";

export default function WabaSignupPage() {
  return (
    <ContentSection>
      <div className="landing-container">
        <h1>Connect WhatsApp Business Account</h1>
        <p>
          Connects to a WhatsApp Business Account (WABA) registered through Meta
          Business Manager. Personal WhatsApp numbers are not supported.{" "}
          <a
            href="https://help.zapier.com/hc/en-us/articles/40123068069005-How-to-get-started-with-WhatsApp-Business-on-Zapier"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more about connecting WhatsApp Business to Zapier.
          </a>
        </p>

        <div className="cta-section">
          <p className="cta-helper-text">
            You&apos;ll be redirected to Meta to securely authorize your
            account.
          </p>
          <div className="waba-signup-button-wrapper">
            <Suspense fallback={<div>Loading...</div>}>
              <WabaSignupModal />
            </Suspense>
          </div>
        </div>
      </div>
    </ContentSection>
  );
}
